import { Handle } from 'react-flow-renderer';

const InputCustomNode = ({ data }) => {
    const customNodeStyles = {
        background: '#F2F2F2 ',
        color: '#222',
        padding: '10px',
        width: 'fit-content',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        marginLeft: '33%',
    };
    return (
        <>
            <div style={customNodeStyles}>
                <Handle type="source" position="bottom" style={{ background: '#EB8C00' }} />
                <span
                    className="appkiticon
                    icon-file-outline"
                    style={{ fontSize: '2rem' }}
                />
            </div>
            <div style={{ marginBottom: '0.1rem' }}>{data.label}</div>
        </>
    );
};

export default InputCustomNode;
